import { render, staticRenderFns } from "./AddInfosDialog.vue?vue&type=template&id=0f3efc30&scoped=true"
import script from "./AddInfosDialog.vue?vue&type=script&lang=js"
export * from "./AddInfosDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3efc30",
  null
  
)

export default component.exports